import { CreneauxDisponibles, CreneauxDisponiblesCalendrier } from '../types/calendrierVisiteModel'
import { typeCreneauEnum } from '../enums/calendrierVisiteEnum'
import { objectGetKeys } from '../../../../utils/ieCompatibility'

const formatNumber = (number: string, length: number) => {
	return number.padStart(length, '0')
}

export const mappingCreneaux = (creneaux: {
	[typeCreneauEnum.AC]: CreneauxDisponibles[],
	[typeCreneauEnum.YFM]: CreneauxDisponibles[]
}) => {
	const creneauxDisponibles: CreneauxDisponiblesCalendrier = {}

	// On trie le résultat pour grouper les horaires / jour
	objectGetKeys(creneaux)
		// On parcourt les créneaux pour les AC / YFM
		.forEach(
			(creneauxDisponiblesType) => {
				// On parcourt les créneaux non disponibles pour chacun des jours de non disponibilités de la response
				objectGetKeys(creneaux[creneauxDisponiblesType as typeCreneauEnum]).forEach(
					(creneauxDisponiblesDate) => {
						// On parcourt chacun des créneaux non disponibles pour le jour concerné
						(creneaux[creneauxDisponiblesType as typeCreneauEnum][creneauxDisponiblesDate as unknown as number] as unknown as string[]).forEach(
							(creneau: string) => {
								const formattedHoraire = formatNumber(creneau.replace(':', ''), 4)
								if (creneauxDisponiblesDate in creneauxDisponibles) {
									// Si l'horaire n'est pas déjà dans la liste des horaires pour le jour concerné
									if (!creneauxDisponibles[creneauxDisponiblesDate as unknown as number].find((item) => item.horaire === formattedHoraire)) {
										creneauxDisponibles[creneauxDisponiblesDate as unknown as number].push({
											horaire: formattedHoraire
										})
										// Puis on les tri par ordre croissant
										creneauxDisponibles[creneauxDisponiblesDate as unknown as number].sort(
											(creneauA, creneauB) => parseInt(creneauA.horaire) > parseInt(creneauB.horaire) ? 1 : -1)
									}
								} else {
									creneauxDisponibles[creneauxDisponiblesDate as unknown as number] = [{
										horaire: formattedHoraire
									}]
								}
							}
						)
					}
				)
			}
		)

	return creneauxDisponibles
}

export const formattageHeure = (creneauValue: string) => `${creneauValue.slice(0, 2)}:${creneauValue.slice(2)}`